import { Setter } from "../../services/ComService"

export default class TimelineItemDTO {
  id: number = -1
  personId: number = -1
  fromDate?: Date
  untilDate?: Date
  tagIds: number[]
  constructor(data: ITimelineItem) {
    this.id = data.id || -1
    this.personId = data.personId || -1
    this.tagIds = data.tagIds || []
    if (data.fromDate) {
      this.fromDate = new Date(data.fromDate)
      this.fromDate.setHours(0)
    }
    if (data.untilDate) {
      this.untilDate = new Date(data.untilDate)
      this.untilDate.setHours(0)
    }
  }

  private getComparibleUntilDate() {
    if (!this.untilDate) {
      return new Date()
    }
    let untilDate = new Date(this.untilDate)
    untilDate.setHours(24)
    return untilDate
  }

  public isPersonDate(personId: number, pointInTime: Date) {
    return (personId === this.personId && this.fromDate && this.untilDate && this.fromDate <= pointInTime && pointInTime <= this.getComparibleUntilDate())
  }

  public isStartDate(personId: number, pointInTime: Date) {
    return (personId === this.personId && this.fromDate && this.fromDate.toDateString() === pointInTime.toDateString())
  }

  public isEndDate(personId: number, pointInTime: Date) {
    return (personId === this.personId && this.untilDate && this.untilDate.toDateString() === pointInTime.toDateString())
  }

  public async delete() {
    await Setter(`timeline/${this.id}`, {
      id: this.id
    }, {method: 'DELETE'})
  }

  public getFirstTagId(): number | undefined {
    return this.tagIds[0]
  }
}

export interface ITimelineItem {
  id?: number
  personId?: number
  fromDate?: Date
  untilDate?: Date
  tagIds?: number[]
}
